//!#system	

<template>
	<v-app>
		<app-navigation></app-navigation>

		<v-main transition="slide-x-transition" class="bgcolor">
			<v-container fluid v-if="storeDataIsLoaded">
				<v-alert type="info" dense v-if="needReload" transition="slide-x-transition">
					A new version is available. <a href="javascript:location.reload(true);" style="color: white;">Refresh</a> your browser to get the latest version.
				</v-alert>
				<v-alert v-if="errorState" type="error">
					{{ errorMessage }}
				</v-alert>
				<keep-alive>
					<router-view :key="$route.fullPath"></router-view>
				</keep-alive>
			</v-container>
			<div v-if="storeDataIsLoaded" class="footer">
				{{footerText}}
			</div>
		</v-main>
		<v-snackbar
			v-model="objectCreated.show"
			:multi-line="objectCreated.multiLine"
			:top="true"
			color="success"
		>
			{{ objectCreated.text }}
			<v-btn
				text
				v-if="objectCreated.linkTo.id"
				@click="goToDetail(objectCreated.linkTo)"
			>
				View
			</v-btn>
			<v-btn
				text
				@click="closeCreatedSnackbar()"
			>
				Close
			</v-btn>
		</v-snackbar>
		<v-snackbar
			v-model="objectUpdated.show"
			:multi-line="objectUpdated.multiLine"
			:top="true"
			color="info"
		>
			{{ objectUpdated.text }}
			<v-btn
				text
				v-if="objectUpdated.linkTo.id"
				@click="goToDetail(objectUpdated.linkTo)"
			>
				View
			</v-btn>
			<v-btn
				text
				@click="closeUpdatedSnackbar()"
			>
				Close
			</v-btn>
		</v-snackbar>
		<v-snackbar
			v-model="objectError.show"
			:multi-line="objectError.multiLine"
			:top="true"
			color="red darken-4"
		>
			{{ objectError.text }}
			<v-btn
				text
				v-if="objectError.linkTo.id"
				@click="goToDetail(objectError.linkTo)"
			>
				View
			</v-btn>
			<v-btn
				text
				@click="closeErrorSnackbar()"
			>
				Close
			</v-btn>
		</v-snackbar>
	</v-app>
</template>

<script>
// 
// https://jsfiddle.net/darkylmnx/ey9acx1z/33/
import store from '@/store';
import AppNavigation from '@/components/AppNavigation';
import apiService from '@/apiService';
import tools from '@/tools';

export default {
	name: 'App',
	data() {
		return {
			needReload: false
		}
	},
	watch: {
		$route: {
			immediate: true,
			handler(to, from) {
				if (to.meta.title) {
					document.title = to.meta.title;
				} else if(to.name) {
					document.title = 'Shine - ' + tools.camelToTitle(tools.underscoreToCamelCase(tools.dashToCamelCase(to.name)));
				}
			}
		}
	},
	computed: {
		storeDataIsLoaded() {
			return this.$store.getters['authentication/isLoaded'] && this.$store.getters['app/isLoaded']
		},
		errorState() {
			return store.state.app.errorState;
		},
		errorMessage() {
			return store.state.app.errorMessage;
		},
		objectCreated() {
			return store.state.app.objectCreated;
		},
		objectUpdated() {
			return store.state.app.objectUpdated;
		},
		objectError() {
			return store.state.app.objectError;
		},
		engineVersion() {
			return store.state.app.engineVersion;
		},
		appVersion() {
			return store.state.app.appVersion;
		},
		footerText() {
			if (this.appVersion && this.engineVersion) return `Engine Version ${this.engineVersion} | App Version ${this.appVersion}`;
		}
	},
	components: {
		AppNavigation
	},
	methods: {
		closeCreatedSnackbar() {
			this.$store.dispatch('app/clearObjectCreated');
		},
		closeUpdatedSnackbar() {
			this.$store.dispatch('app/clearObjectUpdated');
		},
		closeErrorSnackbar() {
			this.$store.dispatch('app/clearObjectError');
		},
		goToDetail(routeInfo, id) {
			tools.goToDetail(routeInfo, id || routeInfo.id);
		},
		evaluateVersions(done) {
			apiService.call({
				path: '/_sys/internals/app-info/versions'
			}, (err, data) => {
				if (err) return done(err);
				if (data.appVersion !== this.appVersion || data.engineVersion !== this.engineVersion) this.needReload = true;
				return done();
			});
		},
		checkVersions() {
			if (!this.appVersion && !this.engineVersion) return; // probably not logged in.
			this.evaluateVersions(err => {
				setTimeout(this.checkVersions, 1000 * 60 * 5); // every 5 minutes
			});
		},
		subscriptionRefresher(done) {
			apiService.call({
				path: '/system/subscriptions'
			}, (err, data) => {
				if (err) return done(err);
				return done();
			});
		},
		checkSubscription() {
			if (!this.appVersion && !this.engineVersion) return; // probably not logged in.
			this.subscriptionRefresher(err => {
				setTimeout(this.checkSubscription, 1000 * 60 * 5); // every 5 minutes
			});
		}
	},
	created() {
		setTimeout(() => {
			this.checkVersions();
			this.checkSubscription();
		}, 1000 * 60 * 5);
	}
};
</script>

<style>
.footer {
	background-color: transparent;
	text-align: center;
	padding: 10px;
	font-size: 12px;
}

.bgcolor {

	background: ;
	/* fallback for old browsers */
	background: -webkit-linear-gradient(to left, #006064, #01579B);  /* Chrome 10-25, Safari 5.1-6 */
	background: linear-gradient(to left, #006064, #01579B); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, 
	/* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

	width: 100%;
	height: 100%;
}

div,
span,
td,
.caption,
.overline {
	font-family: 'Poppins' !important;
}

h1,
h2,
h3,
.v-toolbar__title,
.v-btn__content {
	font-family: "Poppins" !important;
}
.v-application .headline, .v-application .title {
	font-family: "Poppins" !important;
}
.v-application .caption {
	font-family: "Poppins" !important;
}
.v-application .overline {
	font-family: "Poppins" !important;
}
.v-application .text-caption, .v-application .text-overline {
	font-family: "Poppins" !important;
}
.font-mono {
	font-family: "Consolas", monospace !important;
}
.font-mono span {
	font-family: "Consolas", monospace !important;
}

.custom-scrollbar {
	scrollbar-width: thin;
}

.custom-scrollbar::-webkit-scrollbar {
	height: 8px;
	width: 8px;
}

.custom-scrollbar::-webkit-scrollbar-corner {
	background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
	background: rgba(128, 134, 138, .30);
	border-radius: 8px;
}

.v-btn {
	text-transform: none !important;
}

.user-mention {
	text-decoration: none;
}

@font-face {
	font-family: 'password';
	font-style: normal;
	font-weight: 400;
	src: url('/public/password.ttf');
}

input.key {
	font-family: 'password';
}

div.key input {
	font-family: 'password';
}

div.key textarea {
	font-family: 'password';
}

th[role="columnheader"] {
	white-space: nowrap; /*Fix where the sort buttons cause strange formatting*/
}

.v-menu__content {
	scrollbar-width: thin;
}
.v-navigation-drawer__content {
	scrollbar-width: thin;
}
.v-dialog {
	scrollbar-width: thin;
}
body {
	scrollbar-width: thin;
}

.v-menu__content::-webkit-scrollbar {
	height: 8px;
	width: 8px;
	background-color: #fff;
}

.v-menu__content::-webkit-scrollbar-corner {
	background: transparent;
}

.v-menu__content::-webkit-scrollbar-thumb {
	background: rgba(128, 134, 138, .30);
	border-radius: 8px;
}

.v-navigation-drawer__content::-webkit-scrollbar {
	height: 8px;
	width: 8px;
}

.v-navigation-drawer__content::-webkit-scrollbar-corner {
	background: transparent;
}

.v-navigation-drawer__content::-webkit-scrollbar-thumb {
	background: rgba(128, 134, 138, .30);
	border-radius: 8px;
}

.v-dialog::-webkit-scrollbar {
	width: 8px;
	height: 8px;
}

.v-dialog::-webkit-scrollbar-button {
	width: 0px;
	height: 0px;
}

.v-dialog::-webkit-scrollbar-thumb {
	background: #e1e1e1;
	border: 0px none #ffffff;
	border-radius: 50px;
}

.v-dialog::-webkit-scrollbar-thumb:hover {
	background: #ffffff;
}

.v-dialog::-webkit-scrollbar-thumb:active {
	background: #9e9e9e;
}

.v-dialog::-webkit-scrollbar-track {
	background: #666666;
	border: 0px none #ffffff;
	border-radius: 8px;
}

.v-dialog::-webkit-scrollbar-track:hover {
	background: #666666;
}

.v-dialog::-webkit-scrollbar-track:active {
	background: #333333;
}

.v-dialog::-webkit-scrollbar-corner {
	background: transparent;
}

body::-webkit-scrollbar {
	height: 8px;
	width: 8px;
}

body::-webkit-scrollbar-corner {
	background: transparent;
}

body::-webkit-scrollbar-thumb {
	background: rgba(128, 134, 138, .30);
	border-radius: 8px;
}

.code-wrapper pre {
	all: initial;
}

.code-wrapper code {
	all: initial;
}

.prism-editor-wrapper {
	all: initial;
}

code[class*="language-"],
pre[class*="language-"] {
	color: black;
	background: none;
	text-shadow: 0 1px white;
	font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
	font-size: 1em;
	text-align: left;
	white-space: pre;
	word-spacing: normal;
	word-break: normal;
	word-wrap: normal;
	line-height: 1.5;

	-moz-tab-size: 4;
	-o-tab-size: 4;
	tab-size: 4;

	-webkit-hyphens: none;
	-moz-hyphens: none;
	-ms-hyphens: none;
	hyphens: none;
}

pre[class*="language-"]::-moz-selection,
pre[class*="language-"] ::-moz-selection,
code[class*="language-"]::-moz-selection,
code[class*="language-"] ::-moz-selection {
	text-shadow: none;
	background: #b3d4fc;
}

pre[class*="language-"]::selection,
pre[class*="language-"] ::selection,
code[class*="language-"]::selection,
code[class*="language-"] ::selection {
	text-shadow: none;
	background: #b3d4fc;
}

@media print {

	code[class*="language-"],
	pre[class*="language-"] {
		text-shadow: none;
	}
}

/* Code blocks */
pre[class*="language-"] {
	padding: 1em;
	margin: .5em 0;
	overflow: auto;
}

:not(pre)>code[class*="language-"],
pre[class*="language-"] {
	background: #f5f2f0;
}

/* Inline code */
:not(pre)>code[class*="language-"] {
	padding: .1em;
	border-radius: .3em;
	white-space: normal;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
	color: slategray;
}

.token.punctuation {
	color: #999;
}

.token.namespace {
	opacity: .7;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol,
.token.deleted {
	color: #905;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
	color: #690;
}

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
	color: #9a6e3a;
	background: hsla(0, 0%, 100%, .5);
}

.token.atrule,
.token.attr-value,
.token.keyword {
	color: #07a;
}

.token.function,
.token.class-name {
	color: #DD4A68;
}

.token.regex,
.token.important,
.token.variable {
	color: #e90;
}

.token.important,
.token.bold {
	font-weight: bold;
}

.token.italic {
	font-style: italic;
}

.token.entity {
	cursor: help;
}
</style>